<template>
  <div class="schedule-day-card elevation-3 d-flex flex-column justify-center align-center pa-3"
       :class="isDayEnabled ? 'kbGreen' : 'kbRed'"
       style="border-radius: 10px; cursor: pointer; height: 150px; width: 100%">
    <div class="mb-2 text-center">
      <span class="white--text text-capitalize text-h5">
        {{ dayName }}
      </span>
    </div>
    <div class="text-center">
      <span class="white--text"
            style="font-size: 18px"
            v-if="isDaySelected">
        {{ day.startAtHour | zeroFilter }}:{{ day.startAtMinute | zeroFilter }} to
        {{ day.finishAtHour | zeroFilter }}:{{ day.finishAtMinute | zeroFilter }}
      </span>
      <span class="white--text text-capitalize text-h6"
            v-else>
        {{ $t('general.dayDisabled') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    zeroFilter (value) {
      if (parseInt(value) < 10) return `0${value}`
      return value
    }
  },
  computed: {
    isDaySelected () {
      return (this.day && typeof this.day === 'object' && Object.keys(this.day).length)
    }
  },
  props: {
    day: {
      type: Object,
      default: () => {}
    },
    dayName: {
      type: String,
      required: true
    },
    isDayEnabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  .schedule-day-card {
    transition: all ease-in-out 0.2s;
  }
  .schedule-day-card:hover {
    filter: opacity(0.9);
    transform: scale(1.02);
  }
</style>
